module.exports = __webpack_public_path__ + "img/tor_1.36468e4f.jpg";